export type LicenceState = {
    accepted: null | boolean;
    ageVerified: boolean;
};

export const BgcLicence = {
    Casino: 'A+',
    Dice: 'B+',
    Sport: 'F+',
} as const;
export type BgcLicence = typeof BgcLicence[keyof typeof BgcLicence];

export type LicencePreferences = Record<BgcLicence, LicenceState>;
